module.exports = __webpack_public_path__ + "img/sp_article_10.48a20690.jpg";